// extracted by mini-css-extract-plugin
export default {"jsonBlock":"WebhookLogs_jsonBlock__x480Z"};